/*
 * tp-condition-property.js — fuehrt die Line-Item-Property "Zustand" (IT#16260)
 * beim Variantenwechsel nach. Gegenstueck zum Snippet tp-condition-property:
 * dort werden Startwert + JSON-Map (variant_id -> Label) gerendert.
 * Das variant-change-Event der <variant-selection>-Component bubbelt nicht,
 * darum wird jede Instanz einzeln gebunden; der MutationObserver bindet
 * nachgeladene Formulare (Quick-Shop-Modal).
 *
 * ACHTUNG: Der fetch-Wrapper unten repariert den /cart/add.js-Body fuer ALLE
 * "properties[...]"-Keys, nicht nur fuer "Zustand". assets/tp-pv-gate.js
 * (Betreibererklaerung 0 % MwSt., IT#16625) haengt daran — beim Aendern oder
 * Entfernen dieses Assets also auch dort pruefen.
 */
(function () {
  'use strict';

  /* Payload-Reparatur fuer /cart/add.js: Der AddToCartFlyout (Empire-Chunk)
     serialisiert das Formular zu flachem JSON mit woertlichen
     "properties[...]"-Keys, die die JSON-API verwirft. Der Chunk ist zwar
     gefixt, aber content-hash-benannt und ohne ?v= importiert — gecachte
     Browser/CDN-Edges liefern beliebig lange die alte Version. Dieses Asset
     laedt mit ?v=, darum wird der Body hier zusaetzlich vor dem Senden
     genestet (No-op, wenn schon korrekt). */
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : ((input && input.url) || '');
        if (init && typeof init.body === 'string' && url.indexOf('/cart/add') !== -1) {
          var data = JSON.parse(init.body);
          var changed = false, k, m;
          for (k in data) {
            if (!Object.prototype.hasOwnProperty.call(data, k)) { continue; }
            m = /^properties\[(.+)\]$/.exec(k);
            if (m) {
              if (!data.properties || typeof data.properties !== 'object') { data.properties = {}; }
              data.properties[m[1]] = data[k];
              delete data[k];
              changed = true;
            }
          }
          if (changed) { init.body = JSON.stringify(data); }
        }
      } catch (e) { /* kein JSON-Body (FormData etc.) -> unangetastet */ }
      return origFetch.call(this, input, init);
    };
  }

  function setProperty(form, map, variantId) {
    var label = variantId ? map[String(variantId)] : null;
    var inp = form.querySelector('input[data-tp-condition]');
    if (label) {
      if (!inp) {
        inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = 'properties[Zustand]';
        inp.setAttribute('data-tp-condition', '');
        form.appendChild(inp);
      }
      inp.value = label;
    } else if (inp) {
      inp.parentNode.removeChild(inp);
    }
  }

  function bindOne(mapEl) {
    var form = mapEl.closest ? mapEl.closest('form') : null;
    if (!form) { return; }
    var map;
    try { map = JSON.parse(mapEl.textContent); } catch (e) { return; }

    var sel = form.querySelector('variant-selection');

    // Initialstand: das variant-Attribut der Component ist ab Server-Render
    // gueltig; [name=id] hinkt waehrend der Init hinterher (die Component setzt
    // den Wert erst nach dem asynchronen Dispatch -> Race beim Seitenladen).
    var initial = sel ? sel.getAttribute('variant') : null;
    if (!initial) {
      var idEl = form.querySelector('[name="id"]');
      initial = idEl ? idEl.value : null;
    }
    setProperty(form, map, initial);

    if (!sel) { return; }
    // Nicht [name=id] im Handler lesen (siehe oben). detail.variant ist false,
    // wenn der interne Produkt-Fetch der Component (noch) nicht da ist — dann
    // traegt detail.state die rohe Varianten-ID (sonst "selected"/"not-selected").
    sel.addEventListener('variant-change', function (ev) {
      var d = ev.detail || {};
      var id = d.variant ? d.variant.id : d.state;
      setProperty(form, map, id);
    });
  }

  function bindAll() {
    var maps = document.querySelectorAll('script[data-tp-condition-map]'), i;
    for (i = 0; i < maps.length; i++) {
      if (maps[i].hasAttribute('data-tp-condition-bound')) { continue; }
      maps[i].setAttribute('data-tp-condition-bound', '');
      bindOne(maps[i]);
    }
  }

  function observe() {
    if (typeof MutationObserver === 'undefined') { return; }
    var t = null;
    new MutationObserver(function () {
      if (t) { clearTimeout(t); }
      t = setTimeout(bindAll, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.body) { bindAll(); observe(); }
  else {
    document.addEventListener('DOMContentLoaded', function () { bindAll(); observe(); });
  }
})();
